import { render } from "./Loading.vue?vue&type=template&id=72d0e6e4&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=72d0e6e4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-72d0e6e4"

export default script